import { createFileRoute } from "@tanstack/react-router";
import Link from "~/components/Link";
import { trpc } from "~/utils/trpc.client";
import { StudentGroupOverview } from "~/app/(new)/[teamId]/student-groups/[studentGroupId]/StudentGroupOverview";
import { StudentGroupStudentsList } from "~/app/(new)/[teamId]/student-groups/[studentGroupId]/StudentGroupStudentsList";

/** Single student group (was (new)/[teamId]/student-groups/[studentGroupId]/page.tsx). */
export const Route = createFileRoute(
  "/_authed/$teamId/student-groups/$studentGroupId",
)({
  component: StudentGroupPage,
});

function StudentGroupPage() {
  const { teamId, studentGroupId } = Route.useParams();

  const studentGroupQuery = trpc.students.getStudentGroup.useQuery({
    teamId,
    studentGroupId,
  });

  if (studentGroupQuery.isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  if (!studentGroupQuery.data) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-error">Student group not found</div>
      </div>
    );
  }

  const studentGroup = studentGroupQuery.data;

  return (
    <div className="relative m-auto flex h-full w-full max-w-[800px] flex-col gap-4 p-4">
      <div className="breadcrumbs text-sm overflow-visible">
        <ul>
          <li>
            <Link href={`/${teamId}/student-groups`}>Student Groups</Link>
          </li>
          <li>
            <span>{studentGroup.name}</span>
          </li>
        </ul>
      </div>
      <StudentGroupOverview studentGroup={studentGroup} />
      <StudentGroupStudentsList studentGroup={studentGroup} />
    </div>
  );
}
